export default (str: string, length?: number) => {
  if (length === undefined) {
    length = 80;
  }
  if (!str) {
    return str;
  }
  return (str.length > length ? str.substring(0, length) + '...' : str)
}
